import { Trans } from "@lingui/react";
import { memo, type RefObject } from "react";
import { TabId } from "../../utils/tabs.ts";
import "./sections.css";

export const Campaigns = memo(({ ref }: { ref: RefObject<HTMLDivElement | null> }) => {
  return (
    <div id={TabId.Campaigns} className="flex items-center section" ref={ref}>
      <Trans id="dealerBrandingLayout.campaigns.title" message="Campaigns" />
    </div>
  );
});
